import { useCallback, useState } from "react";
import useResize from "../use-resize";
import { MAX_MOBILE_WIDTH } from "../../constants";

const useResponsive = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useResize(
    useCallback(() => {
      // MAX_MOBILE_WIDTH should be changed to something better
      if (window.innerWidth < MAX_MOBILE_WIDTH) setIsMobile(true);
      else setIsMobile(false);
    }, [])
  );

  return isMobile;
};

export default useResponsive;
